import { render, staticRenderFns } from "./SamImage.vue?vue&type=template&id=09e9b81a&scoped=true&shadow"
import script from "./SamImage.vue?vue&type=script&lang=js&shadow"
export * from "./SamImage.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamImage.vue?vue&type=style&index=0&id=09e9b81a&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "09e9b81a",
  null
  ,true
)

export default component.exports